export default __webpack_public_path__ + "static/media/third-order.cb365552.png";